import { render } from "./LeftArrowIcon.vue?vue&type=template&id=40ed2a4e"
const script = {}

import exportComponent from "/home/runner/work/margaretriver.com/margaretriver.com/river/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__